import { Tooltip } from 'antd';
import { CSSProperties, ReactNode, useEffect, useRef, useState } from 'react';

const horizontalStyle: CSSProperties = { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };
const verticalStyle: CSSProperties = { overflow: 'hidden', display: '-webkit-box', WebkitBoxOrient: 'vertical' };
// If column title exceeds then add ellipsis (...) to end of the title
const EllipsisTooltip = ({
  children,
  title,
  type = 'horizontal',
  lineClamp = 2,
}: {
  children: React.ReactNode | string;
  title?: string | ReactNode;
  type?: 'horizontal' | 'vertical';
  lineClamp?: number;
}) => {
  const textRef = useRef<any>(null);
  const [isEllipsis, setIsEllipsis] = useState(false);

  // Check title exceeds the column
  useEffect(() => {
    const checkEllipsis = () => {
      const condition =
        type === 'horizontal'
          ? textRef.current.scrollWidth > textRef.current.offsetWidth
          : textRef.current.scrollHeight > textRef.current.offsetHeight;

      if (textRef.current) {
        setIsEllipsis(condition);
      }
    };
    checkEllipsis();
    window.addEventListener('resize', checkEllipsis);
    return () => window.removeEventListener('resize', checkEllipsis);
  }, [children, type]);

  return (
    <Tooltip getPopupContainer={(node) => node.parentNode as HTMLElement} title={isEllipsis ? title || children : ''}>
      <div
        ref={textRef}
        style={type === 'horizontal' ? horizontalStyle : { ...verticalStyle, WebkitLineClamp: lineClamp.toString() }}
      >
        {children}
      </div>
    </Tooltip>
  );
};

export default EllipsisTooltip;
